/*
 * @Author: DG
 * @Date: 2020-02-07 10:38:32
 * @LastEditors: DG
 * @LastEditTime: 2020-10-22 14:48:23
 * @Description: file content
 */
import Cookies from 'js-cookie';
import { STATION } from './const';

function setCookie(c_name, value, expiredays) {
  const exdate = new Date();
  const { ENV } = window.__SMART__;
  exdate.setDate(exdate.getDate() + expiredays);
  document.cookie = `${c_name}=${escape(value)};expires=${exdate.toGMTString()};path=/;domain=.${
    window.location.hostname
  }`;
  if (ENV === 'dev' || ENV === 'test') {
    document.cookie = `${c_name}=${escape(value)};expires=${exdate.toGMTString()};path=/;domain=${
      window.location.hostname
    }`;
  }
}

const getCookie = (name) => {
  let arr,
    reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
  if ((arr = document.cookie.match(reg))) return unescape(arr[2]);
  else return null;
};

// 切换到顺丰云之后，sit环境和生产环境的域名只有一个 .sit 的区别，所以不能在父级域名下设置cookie了，会导致测试环境获取cookie混乱
// const isIp = (str) => {
//   const pattern = /((2(5[0-5]|[0-4]\d))|[0-1]?\d{1,2})(\.((2(5[0-5]|[0-4]\d))|[0-1]?\d{1,2})){3}/g;
//   return pattern.test(str);
// };

// const getRootDomain = (domain) => {
//   if (isIp(domain)) {
//     return domain;
//   }
//   return domain
//     .split('.')
//     .splice(1)
//     .join('.');
// };

// const rootDomain = getRootDomain(document.domain);
const curDomain = window.location.hostname;

// 过期时间
const expires = 365;

export const setStationID = (value) => {
  Cookies.set(STATION, value, {
    expires,
    // domain: curDomain,
  });
};

export const getStationID = () => {
  return Cookies.get(STATION, {
    // domain: curDomain,
  });
};

export const setStationCode = (value) => {
  Cookies.set('op_station_code', value, {
    expires,
    // domain: curDomain,
  });
};

export const getStationCode = () => {
  return Cookies.get('op_station_code', {
    // domain: curDomain,
  });
};

export { setCookie, getCookie };
